import _ from 'underscore';
import ScrollManager from 'components/manager/ScrollManager';
import Popin from './Popin';

class Header {

  lastScrollTop = 0;
  popinOpened = false;
  currentSectionId = null;

  constructor(el) {
    this.sections = [].slice.call(el.parentNode.children);
    this.sections.shift();

    this.aboutButton = el.querySelector('.about-button');
    this.nav = el.querySelector('header');
    this.el = el;

    this.quickAccess = {
      backToTop : el.querySelector('.back-to-top'),
      scrollDown : el.querySelector('.scroll-down'),
      projects : el.querySelector('.project-dots'),
      projectDots : [].slice.call(el.querySelectorAll('.project-dot'))
    }

    this.aboutButton.addEventListener('click', this.togglePopin);

    this.duplicateAbout();
    this.addEvents();
    this.onResize();
  }

  duplicateAbout() {
    const about = document.querySelector('.popin-about');
    this.popinAbout = new Popin(about);
  }

  togglePopin = (event) => {
    event.preventDefault();
    const open = !this.popinOpened;

    if (open) {
      this.popinAbout.show();
      ScrollManager.freeze();
      this.aboutButton.classList.add('opened');
    } else {
      this.popinAbout.hide();
      ScrollManager.unfreeze();
      this.aboutButton.classList.remove('opened');
    }

    this.popinOpened = open;
    this.updateState(true);
  }

  addEvents() {
    ScrollManager.on('scroll', this.updateState);
  }

  currentSectionInfo(scrollTop, zone = .5) {
    return _.find(this.sectionInfos, (info)=> info.bottom > (scrollTop + this.windowHeight * zone));
  }

  updateState = (force = false) => {

    if (ScrollManager.animating) return;

    const scrollTop = ScrollManager.currentScroll();
    const section = this.popinOpened ? this.sectionInfos[0] : this.currentSectionInfo(scrollTop);

    if (!section) return;

    const tgl = (b) => b ? 'add':'remove';
    const hideClassName = 'hide';

    // Toggle nav state;
    // const scrollTopDiff = this.lastScrollTop - scrollTop;
    // if (scrollTop > 0 || scrollTopDiff > 0) {
    //   this.nav.classList[tgl(scrollTopDiff < 0)](hideClassName);
    // }
    // this.lastScrollTop = scrollTop;


    if (section.id == this.currentSectionId && !force) return;

      // Toggle Quick link states
      const isBackToTop = section.id != 'header';
      const isProject = section.id.indexOf('project') > -1;

      this.quickAccess.scrollDown.classList[tgl(isBackToTop || this.popinOpened)](hideClassName);
      this.quickAccess.backToTop.classList[tgl(!isBackToTop || this.popinOpened)](hideClassName);
      this.quickAccess.projects.classList[tgl(!isProject)](hideClassName || this.popinOpened);

      // Select current dot
      if (isProject) {
        _.each(this.quickAccess.projectDots, (dot)=> {
          const isCurrent = dot.classList.contains('dot-'+section.id);
          dot.classList[tgl(isCurrent)]('current');
        })
      }


    //Apply color
    // const topSection = this.currentSectionInfo(scrollTop, 0.05);
    // const bottomSection = this.currentSectionInfo(scrollTop, .95);
    this.nav.style.color = section.color;
    this.quickAccess.projects.style.color = section.color;
    this.quickAccess.projects.style.borderColor = section.color;

    this.currentSectionId = section.id;
  }

  storeSectionInfos() {
    const scrollTop = ScrollManager.currentScroll();
    this.sectionInfos = _.map(this.sections, (element) => {

      return {
        id : element.getAttribute('id'),
        bottom : element.getBoundingClientRect().bottom + scrollTop,
        color : window.getComputedStyle(element ,null).getPropertyValue('color')
      }

    });
  }

  onResize = () => {
    this.windowHeight = window.innerHeight;
    this.currentSectionId = null;
    this.storeSectionInfos();
    this.updateState();
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/sections/Header.js